export const PAGE_PERFORMANCE_METRICS = {
    CLS: 'CLS',
    FCP: 'FCP',
    TBT: 'TBT',
    LCP: 'LCP',
    TTI: 'TTI',
    SI: 'SI',
} as const;
